import { instance, simpleInstance } from '@/api/instances'
import { addMixedDataLog } from '@/components/pillars/utils/addLog'

const fetchMemberPhotoURL = async (store, photo) => {
  if (!photo?.url) return

  try {
    const response = await simpleInstance.get(photo.url)
    return response
  } catch (error) {
    store.commit(
      'errors/setError',
      'Não foi possível recuperar a foto de perfil do membro',
      { root: true }
    )
  }
}

const setMemberPhotoURL = async (store, photo) => {
  store.commit('setPhotoURL', undefined)
  const photoURL = await store.dispatch('fetchMemberPhotoURL', photo)
  store.commit('setPhotoURL', photoURL)
}

const uploadPhoto = async (store, { file, personId }) => {
  try {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('personId', personId)
    formData.append('fileName', file.name)

    const photo = await simpleInstance.post(
      `${process.env.VUE_APP_API_PREFIX_URL}/persons/${personId}/photo`,
      {
        json: formData
      },
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )

    setMemberPhotoURL(store, photo)
    return { hasError: false }
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'pillars/profile/uploadPhoto' },
      { root: true }
    )
    return { hasError: true }
  }
}

const fetchProfile = async (store, { personId, signal }) => {
  if (store.state.profile.id === personId) return

  store.commit('setProfile', {})
  store.commit('setPhotoURL', '')
  store.commit('errors/setCriticalError', null, { root: true })

  try {
    const profile = await instance.get(`persons/${personId}`, { signal })

    if (store.rootState.pillars.personId === personId) {
      store.commit('setProfile', { ...profile })
      setMemberPhotoURL(store, profile.photo)
    } else {
      addMixedDataLog('fetchProfile')
      store.commit(
        'errors/setCriticalError',
        {
          type: 'mixed_data',
          context: 'profile'
        },
        { root: true }
      )
    }

    store.dispatch('fetchHealthCareTeam', { personId, signal })
  } catch (error) {
    store.dispatch(
      'errors/setError',
      {
        context: 'profile',
        message: 'Ops, erro ao recuperar as informações de perfil',
        error
      },
      { root: true }
    )
  }
}

const fetchHealthCareTeam = async (store, { personId, signal }) => {
  try {
    const healthCareTeam = await instance.get(
      `persons/${personId}/healthcare_team`,
      { signal }
    )

    store.commit('updateProfile', {
      healthCareTeam: healthCareTeam.healthcareTeam
    })
  } catch (error) {
    store.dispatch(
      'errors/setError',
      {
        message: 'Ops, erro ao recuperar as informações de time de saúde',
        error
      },
      { root: true }
    )
  }
}

const fetchLiteProfile = async (store, { personId, signal }) => {
  store.commit('setLiteProfile', {})
  if (!personId) {
    return
  }
  try {
    const response = await instance.get(`persons/${personId}/light`, {
      signal
    })

    store.commit('setLiteProfile', response)
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'fetchLiteProfile' },
      { root: true }
    )
  }
}

const updateProfile = async store => {
  try {
    const reponseBody = await instance.put(
      `persons/${store.state.profile.id}`,
      {
        json: store.state.profile
      }
    )

    store.commit('updateProfile', {
      version: reponseBody.version
    })
    store.commit('updateLiteProfile', reponseBody)
  } catch (error) {
    store.dispatch(
      'errors/setError',
      {
        error,
        request: 'pillars/profile/updateProfile',
        context: 'profile'
      },
      { root: true }
    )
  }
}

const clearLiteProfile = store => {
  store.commit('clearLiteProfile')
  store.commit('clearPhotoUrl')
}

const clearProfile = store => {
  store.commit('setProfile', {})
  store.commit('setPhotoURL', '')
}

export default {
  fetchMemberPhotoURL,
  setMemberPhotoURL,
  uploadPhoto,
  fetchProfile,
  fetchLiteProfile,
  updateProfile,
  clearLiteProfile,
  fetchHealthCareTeam,
  clearProfile
}
